module.exports = __webpack_public_path__ + "img/CC-Logo-White.1144d714.svg";